import React, { useRef, useState } from "react";

import brand1 from "assets/img/brand/5/brand-1.png";
import brand2 from "assets/img/brand/5/brand-2.png";
import brand3 from "assets/img/brand/5/brand-3.png";
import brand4 from "assets/img/brand/5/brand-4.png";
import brand5 from "assets/img/brand/5/brand-5.png";
import brand6 from "assets/img/brand/5/brand-6.png";
import brand7 from "assets/img/brand/5/brand-7.png";
import brand8 from "assets/img/brand/5/brand-8.png";
import numeroUno from "assets/img/brand/numero-uno.png";
import adnoc from "assets/img/brand/adnoc.png";
import saudiAramco from "assets/img/brand/saudi-aramco.png";
import lilly from "assets/img/brand/lilly.png";
import iqos from "assets/img/brand/iqos.png";
import gamingPartner from "assets/img/brand/gaming-partner.png";
import desoniqStudio from "assets/img/brand/desoniq-studio.png";
import cyberhub from "assets/img/brand/145-cyberhub.png";

const brandLogos = [
  { src: brand1, alt: "Partner brand logo", size: [133, 33], bounds: "0 0 133 33" },
  { src: brand2, alt: "Partner brand logo", size: [133, 33], bounds: "19 0 95 33" },
  { src: brand3, alt: "Partner brand logo", size: [133, 33], bounds: "0 0 133 33" },
  { src: brand4, alt: "Partner brand logo", size: [133, 33], bounds: "0 0 133 33" },
  { src: brand5, alt: "Partner brand logo", size: [59, 71], bounds: "3 0 52 71" },
  { src: brand6, alt: "Partner brand logo", size: [59, 37], bounds: "1 1 58 35" },
  { src: brand7, alt: "Partner brand logo", size: [127, 37], bounds: "9 7 108 23" },
  { src: brand8, alt: "Partner brand logo", size: [127, 65], bounds: "0 9 127 54" },
  { src: numeroUno, alt: "Numero Uno logo", size: [233, 233], bounds: "27 23 180 200" },
  { src: adnoc, alt: "ADNOC logo", size: [554, 554], bounds: "135 47 286 462" },
  { src: saudiAramco, alt: "Saudi Aramco logo", size: [350, 350], bounds: "37 137 276 78" },
  { src: lilly, alt: "Lilly - A Medicine Company logo", size: [1024, 630], bounds: "150 151 724 331" },
  { src: iqos, alt: "IQOS logo", size: [673, 553], bounds: "56 8 560 532" },
  { src: gamingPartner, alt: "Gaming partner logo", size: [1540, 1624], bounds: "0 0 1540 1624", dark: true },
  { src: desoniqStudio, alt: "Desoniq Studio logo", size: [1600, 491], bounds: "28 16 1548 448", dark: true },
  { src: cyberhub, alt: "145 Cyberhub cafe and bar logo", size: [447, 447], bounds: "68 68 336 292" },
];

const BrandsMarquee = ({ logos, reverse = false }) => {
  const marqueeRef = useRef(null);
  const trackRef = useRef(null);
  const dragStartRef = useRef({ x: 0, offset: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragOffset, setDragOffset] = useState(0);
  const marqueeLogos = [0, 1, 2].flatMap(() => logos);

  const normalizeOffset = (offset) => {
    const track = trackRef.current;
    const cycleWidth = track ? track.scrollWidth / 3 : 0;

    if (!cycleWidth) return offset;

    const normalized = ((offset % cycleWidth) + cycleWidth) % cycleWidth;
    return normalized === 0 ? 0 : normalized - cycleWidth;
  };

  const handlePointerDown = (event) => {
    const marquee = marqueeRef.current;
    if (!marquee) return;

    setIsDragging(true);
    dragStartRef.current = {
      x: event.clientX,
      offset: dragOffset,
    };
    marquee.setPointerCapture(event.pointerId);
  };

  const handlePointerMove = (event) => {
    const marquee = marqueeRef.current;
    if (!isDragging || !marquee) return;

    event.preventDefault();
    const dragDistance = event.clientX - dragStartRef.current.x;
    setDragOffset(normalizeOffset(dragStartRef.current.offset + dragDistance));
  };

  const stopDragging = (event) => {
    const marquee = marqueeRef.current;
    setIsDragging(false);

    if (marquee?.hasPointerCapture?.(event.pointerId)) {
      marquee.releasePointerCapture(event.pointerId);
    }
  };

  return (
      <div
        ref={marqueeRef}
        className={`trusted-brands__marquee${reverse ? " trusted-brands__marquee--reverse" : ""}${isDragging ? " is-dragging" : ""}`}
        aria-label="Brands we have worked with"
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={stopDragging}
        onPointerCancel={stopDragging}
        onPointerLeave={isDragging ? stopDragging : undefined}
      >
        <div
          ref={trackRef}
          className="trusted-brands__track"
          style={{ "--trusted-brands-drag-offset": `${dragOffset}px` }}
        >
          {marqueeLogos.map((logo, index) => (
            <div
              className={`trusted-brands__item${logo.dark ? " trusted-brands__item--dark" : ""}`}
              key={`${logo.alt}-${index}`}
              aria-hidden={index >= logos.length ? true : undefined}
            >
              <svg
                viewBox={logo.bounds}
                role="img"
                aria-label={logo.alt}
                preserveAspectRatio="xMidYMid meet"
              >
                <image href={logo.src} width={logo.size[0]} height={logo.size[1]} />
              </svg>
            </div>
          ))}
        </div>
      </div>
  );
};

const HomeTrustedBrands = () => (
  <section className="trusted-brands__area">
    <div className="container">
      <div className="trusted-brands__heading text-center">
        <span>Trusted Collaborations</span>
        <h3>Brands We Have Worked With</h3>
      </div>
    </div>
    <div className="trusted-brands__desktop-rows">
      <BrandsMarquee logos={brandLogos.filter((_, index) => index % 2 === 0)} />
      <BrandsMarquee logos={brandLogos.filter((_, index) => index % 2 === 1)} reverse />
    </div>
    <div className="trusted-brands__mobile-row">
      <BrandsMarquee logos={brandLogos} />
    </div>
  </section>
);

export default HomeTrustedBrands;
